








import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';
import { Cell } from '@/main/utils/table';
import { TABLE_DATA, TABLE_DATA_EXPORT } from '@/main/store/listEditTypes';
import { printButton } from '@/main/utils/tableOperations';
import { vydejkaTisk, reservePartTisk } from '@/modules/servis/zakazka/components/vydejky/api';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { REPORT_TYPES, RESERVE_PARTS } from '../constants';
import { apiProvider } from '../api';

export default Vue.extend({
	name: 'ReserveParts',
	components: {
		DmsPdfDialog,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			RESERVE_PARTS,
			dependencies: {
				RESERVE_PARTS,
			},
			vydejkaId: null as number | null,
			printButton,
			vydejkaTisk,
			reservePartTisk,
			showTiskDialog: false,
		};
	},
	computed: {
		...genVuexComputeds(store),
		extraButtons(): {} {
			return { ...printButton(this.printVydejka) };
		},
		vydejkaFilter(): { Id: number } {
			return {
				Id: this.vydejkaId!,
			};
		},
	},
	methods: {
		async refreshTable(name: string) {
			await this.$store.dispatch(`${this.storeUri}/${name}_${TABLE_DATA}`, { filter: (this as any)[`${name}Filter`] });
		},
		async exportTable(name: string) {
			await this.$store.dispatch(`${this.storeUri}/${name}_${TABLE_DATA_EXPORT}`);
		},
		async printVydejka(e: Event, cells: Cell[]) {
			[this.vydejkaId] = cells;
			this.showTiskDialog = true;
		},
		markReportAsPrinted() {
			apiProvider.markReportAsPrinted(this.vydejkaFilter.Id, REPORT_TYPES.StoreRequisitionForm);
		},

	},
});
